"use client";
import{useEffect as o}from"react";import{useAdEvents as e}from"../hooks/use-ad-event.js";const n=n=>{const t=e(n.adDemand,n.id,n.adDimension);return o((()=>{t.onFailed()}),[]),null};export{n as default};
